import {
  address,
  linkBrand,
  nameApp,
  nameBrand,
  nameCasino,
  suportMail,
  telegram,
  telephone,
  viber,
  facebook,
  instagram
} from '~/util/defaultInfo'

const schemaUrl = 'https://schema.org'
export const jsonldArticle = (url, seo, path, mainEntity = []) => {
  if (!seo) {
    return
  }
  else {
    return {
      '@context': schemaUrl,
      '@type': 'Article',
      articleBody: seo.footer[0],
      mainEntity: mainEntity,
      author: nameBrand,
      headline: seo.h1,
      image: '/img/general/logo.svg',
      description: seo.description,
      publisher: {
        '@type': 'Organization',
        name: nameBrand,
        logo: {
          '@type': 'ImageObject',
          url: '/img/general/logo.svg',
        },
      },
      datePublished: '2021-01-01T08:00:00+08:00',
      dateModified: new Date().toISOString(),
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': path,
      },

    }

  }
}
export const jsonldBreadcrumbs = (url, localPaths, listElements) => {
  if (!listElements) {
    return
  }
  else {
    const crumbs = listElements
      .map((item,index) => {
        return {
          '@type': 'ListItem',
          'position': index,
          'name': item.title,
          'item': url + localPaths(item.path).replace(/\/$/, ''),
        }
      })
    return {
      '@context': schemaUrl,
      '@type': 'BreadcrumbList',
      'itemListElement': crumbs,
    }
  }
}
export const jsonldEvent = (url, element, path, locale) => {
  if (!element) {
    return
  }
  else {
    return {
      '@context': schemaUrl,
      '@type': 'Event',
      name: element.text[locale].header,
      startDate: new Date(element.start_date).toISOString(),
      endDate: new Date(element.end_date).toISOString(),
      eventStatus: `${url}/EventScheduled`,
      eventAttendanceMode: `${url}/OnlineEventAttendanceMode`,
      location: {
        type: 'Place',
        url: `${url}${path}/${element.term}`,
      },
      image: element.images.main_banner_logo_desktop,
      description: element.text[locale].localized_description,
      offers: {
        type: 'Offer',
        price: element.ticket_price/100,
        priceCurrency: 'UAH',
        url: `${url}${path}/${element.term}`,
        availability: `${url}/InStock`,
        validFrom: `${element.start_date}+03:00`,
      },
      performer: {
        type: 'Person',
        name: `Автор: ${nameBrand}`,
      },
      organizer: {
        type: 'Organization',
        name: nameCasino,
        url: url,
      },
    }
  }
}
export const jsonldCasino = (url, microData) => {
  if (!microData) {
    return
  }
  else {
    return {
      '@context': schemaUrl,
      '@type': 'Casino',
      url: url,
      logo: `${url}/img/logo.svg`,
      areaServed: 'Ukraine',
      brand: microData.brand,
      description: microData.description,
      disambiguatingDescription: microData.disambiguatingDescription,
      name: microData.name,
      email: suportMail,
      address: address,
      openingHours: ['Monday through Sunday, all day'],
      telephone: telephone,
      image: `${url}/img/main-page/register-bonus.webp`,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '23921',
      },
      priceRange: '$$$',
      paymentAccepted: 'Visa, Master Card, ApplePay, AndroidPay',
      sameAs: [
        viber,
        facebook,
        instagram,
        telegram,
      ],
      potentialAction: {
        '@type': 'SearchAction',
        target: `${url}/search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    }
  }
}
export const jsonldApplication = () => {
  return  {
    '@context': schemaUrl,
    '@type': 'SoftwareApplication',
    'name': nameApp,
    'operatingSystem': 'Windows, MacOS',
    'applicationCategory': 'Games',
    'offers': {
      '@type': 'Offer',
      'category': 'free',
      'price': '0',
      'priceCurrency': 'USD',
      'seller': {
        '@type': 'Organization',
        'name': nameBrand,
      },
    },
    'softwareVersion': '3.0',
    'datePublished': '2024-01-01',
    'aggregateRating': {
      '@type': 'AggregateRating',
      'ratingValue': '4.5',
      'reviewCount': '276',
    },
    'description': nameBrand,
    'screenshot': 'https://example.com/screenshot.jpg',
    'applicationSubCategory': 'casino games',
    'url': 'https://example.com/casino-app',
    'author': {
      '@type': 'organisation',
      'name': linkBrand,
    },
  }
}
